export const designStatuses = ['TODO', 'IN_PROGRESS', 'VALIDATED'] as const
export type DesignStatus = (typeof designStatuses)[number]

export const designStatusLabel: Record<DesignStatus, string> = {
  TODO: 'À faire',
  IN_PROGRESS: 'En cours',
  VALIDATED: 'Validé',
}
